import { render, staticRenderFns } from "./cab-to-goa.vue?vue&type=template&id=59c5aab3&scoped=true"
import script from "./cab-to-goa.vue?vue&type=script&lang=js"
export * from "./cab-to-goa.vue?vue&type=script&lang=js"
import style0 from "./cab-to-goa.vue?vue&type=style&index=0&id=59c5aab3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c5aab3",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TaxiCard: require('/workspace/components/TaxiCard.vue').default,FaqCard: require('/workspace/components/FaqCard.vue').default})
